import React, { useState } from 'react';
import { WalletIcon, InstagramIcon } from 'lucide-react';
import { TermsModal } from './TermsModal';
import { PrivacyModal } from './PrivacyModal';
import { CookiesModal } from './CookiesModal';
export function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showCookies, setShowCookies] = useState(false);
  return <>
      <footer className="bg-gray-50 border-t border-gray-200 pt-16 pb-8" data-id="element-101">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12" data-id="element-103">
            <div className="col-span-1 md:col-span-1" data-id="element-104">
              <div className="flex items-center gap-2 mb-4" data-id="element-105">
                <div className="bg-emerald-600 p-1.5 rounded-lg" data-id="element-106">
                  <WalletIcon className="h-5 w-5 text-white" data-id="element-107" />
                </div>
                <span className="text-xl font-bold text-gray-900" data-id="element-108">
                  ClubAhorra
                </span>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-6" data-id="element-109">
                La plataforma líder de descuentos y beneficios. Conectamos a
                usuarios inteligentes con las mejores marcas.
              </p>
              <div className="flex space-x-4" data-id="element-110">
                <a href="https://www.instagram.com/clubahorra?igsh=MWxlYnpwZWFkcHVxbA==" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-emerald-600 transition-colors" data-id="element-111">
                  <InstagramIcon className="h-5 w-5" data-id="element-112" />
                </a>
              </div>
            </div>

            <div data-id="element-113">
              <h4 className="font-bold text-gray-900 mb-4" data-id="element-114">Legal</h4>
              <ul className="space-y-3 text-sm text-gray-600" data-id="element-115">
                <li data-id="element-116">
                  <button onClick={() => setShowTerms(true)} className="hover:text-emerald-600 text-left" data-id="element-117">
                    Términos y Condiciones
                  </button>
                </li>
                <li data-id="element-118">
                  <button onClick={() => setShowPrivacy(true)} className="hover:text-emerald-600 text-left" data-id="element-119">
                    Política de Privacidad y Protección de Datos
                  </button>
                </li>
                <li data-id="element-120">
                  <button onClick={() => setShowCookies(true)} className="hover:text-emerald-600 text-left" data-id="element-121">
                    Cookies
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-122">
            <p className="text-gray-400 text-sm" data-id="element-123">
              © 2026 ClubAhorra es una marca de la Plataforma Benefika de
              TicketMaestro. Todos los derechos reservados.
            </p>
            <div className="flex gap-6" data-id="element-124">
              <span className="text-gray-400 text-sm" data-id="element-125">
                Hecho con ❤️ para ahorrar
              </span>
            </div>
          </div>
        </div>
      </footer>

      <TermsModal isOpen={showTerms} onClose={() => setShowTerms(false)} data-id="element-126" />
      <PrivacyModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} data-id="element-127" />
      <CookiesModal isOpen={showCookies} onClose={() => setShowCookies(false)} data-id="element-128" />
    </>;
}